function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 7C4.44772 7 4 6.55228 4 6L4 3C4 2.44772 4.44772 2 5 2L8 2C8.55228 2 9 2.44772 9 3L9 6C9 6.55228 8.55228 7 8 7L5 7Z",
  fill: "#009C63"
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 22,
  width: 5,
  height: 5,
  rx: 1,
  transform: "rotate(-90 15 22)",
  fill: "#009C63"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 14.5C15.4477 14.5 15 14.0523 15 13.5L15 10.5C15 9.94772 15.4477 9.5 16 9.5L19 9.5C19.5523 9.5 20 9.94772 20 10.5L20 13.5C20 14.0523 19.5523 14.5 19 14.5L16 14.5Z",
  fill: "#009C63"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 7,
  width: 5,
  height: 5,
  rx: 1,
  transform: "rotate(-90 15 7)",
  fill: "#009C63"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11 12.5L11 11.5L17 11.5L17 12.5L11 12.5Z",
  fill: "#009C63"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.5C8 4.22386 8.22386 4 8.5 4L12 4L15 4C15.2761 4 15.5 4.22386 15.5 4.5C15.5 4.77614 15.2761 5 15 5L12.5 5C12.2239 5 12 5.22386 12 5.5L12 18.5C12 18.7761 12.2239 19 12.5 19L15 19C15.2761 19 15.5 19.2239 15.5 19.5C15.5 19.7761 15.2761 20 15 20L12 20H11.5C11.2239 20 11 19.7761 11 19.5L11 5.5C11 5.22386 10.7761 5 10.5 5L8.5 5C8.22386 5 8 4.77614 8 4.5Z",
  fill: "#009C63"
});
const SvgTreeButton = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTreeButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/treeButton.e0539af1.svg";
export { ForwardRef as ReactComponent };